export default {
  // Page title and subtitle
  'page.mainTitle': 'Unix टाइमस्टैम्प कनवर्टर',
  'page.mainTitleSEO': 'Unix टाइमस्टैम्प कनवर्टर और Epoch समय टूल',
  'page.subtitle': 'Unix टाइमस्टैम्प को डेटाटाइम में और डेटाटाइम को टाइमस्टैम्प में तुरंत कन्वर्ट करें',
  'page.title': 'टाइमस्टैम्प कनवर्टर',
  'page.currentTimestamp': 'वर्तमान Unix टाइमस्टैम्प',
  'page.currentEpochTime': 'वर्तमान Unix Epoch समय',
  'page.milliseconds': 'मिलीसेकंड (13 अंक)',
  'page.seconds': 'सेकंड (10 अंक)',
  'page.millisecondsOnly': 'मिलीसेकंड',
  'page.secondsOnly': 'सेकंड',
  'page.currentDateTime': 'वर्तमान तारीख और समय',

  // Interactive Converter
  'page.interactiveConverter': 'इंटरैक्टिव टाइमस्टैम्प ↔ तारीख कनवर्टर',
  'page.timestampToDatetimeTitle': 'Unix टाइमस्टैम्प से डेटाटाइम',
  'page.datetimeToTimestampTitle': 'डेटाटाइम से टाइमस्टैम्प',
  'page.ms': 'MS',
  'page.sec': 'SEC',
  'page.autoDetect': 'स्वतः-पता लगाएं प्रारूप',
  'page.detected': 'पता लगाया',
  'page.digits': 'अंक',
  'page.convertedTo': 'में परिवर्तित',
  'page.converterTip': 'वास्तविक समय द्विदिशात्मक रूपांतरण',
  'page.converterTipDesc': 'तुरंत रूपांतरण देखने के लिए किसी भी फ़ील्ड में टाइप करें। स्वचालित रूप से 10-अंक (सेकंड) या 13-अंक (मिलीसेकंड) टाइमस्टैम्प का पता लगाता है।',

  // Conversion sections
  'page.timestampToDateTime': 'टाइमस्टैम्प से तारीख समय',
  'page.dateTimeToTimestamp': 'तारीख समय से टाइमस्टैम्प',
  'page.selectFormat': 'प्रारूप चुनें',
  'page.enterTimestamp': 'टाइमस्टैम्प दर्ज करें',
  'page.enterDateTime': 'तारीख और समय चुनें',
  'page.convertedResult': 'परिवर्तित परिणाम',
  'page.yourTimeZone': 'आपका समय क्षेत्र',
  'page.relative': 'सापेक्ष',

  // Relative time translations
  'page.relativeTime.secondsAgo': '{{seconds}} सेकंड पहले',
  'page.relativeTime.minutesAgo': '{{minutes}} मिनट पहले',
  'page.relativeTime.hoursAgo': '{{hours}} घंटे पहले',
  'page.relativeTime.daysAgo': '{{days}} दिन पहले',
  'page.relativeTime.inSeconds': '{{seconds}} सेकंड में',
  'page.relativeTime.inMinutes': '{{minutes}} मिनट में',
  'page.relativeTime.inHours': '{{hours}} घंटे में',
  'page.relativeTime.inDays': '{{days}} दिन में',

  // What is Timestamp section (FAQ)
  'page.faq': 'अक्सर पूछे जाने वाले प्रश्न (FAQ)',
  'page.whatIsTimestamp': 'Unix टाइमस्टैम्प क्या है?',
  'page.timestampIntro': 'Unix टाइमस्टैम्प (जिसे Epoch समय या POSIX समय के रूप में भी जाना जाता है) समय में एक बिंदु का वर्णन करने के लिए एक प्रणाली है जो 1 जनवरी 1970 को 00:00:00 UTC (Unix epoch) के बाद से बीते सेकंड (या मिलीसेकंड) की संख्या के रूप में होती है, लीप सेकंड की गिनती नहीं करती। यह मानक कंप्यूटिंग और प्रोग्रामिंग में तारीखों और समय का प्रतिनिधित्व करने के लिए एक सरल, सार्वभौमिक तरीके के रूप में व्यापक रूप से उपयोग किया जाता है।',

  'page.unixEpochTitle': 'Unix Epoch - समय की शुरुआत',
  'page.unixEpochDesc': 'Unix epoch 1 जनवरी 1970 को आधी रात UTC है। सभी Unix टाइमस्टैम्प समय में इस विशिष्ट क्षण से गणना किए जाते हैं, जो इसे दुनिया भर में कंप्यूटर सिस्टम के लिए एक सार्वभौमिक संदर्भ बिंदु बनाता है।',

  'page.timestampFormatsTitle': 'टाइमस्टैम्प प्रारूप',
  'page.secondsFormat': 'सेकंड (10-अंक)',
  'page.secondsFormatDesc': 'मानक Unix टाइमस्टैम्प जो epoch के बाद से सेकंड का प्रतिनिधित्व करता है। उदाहरण: 1734598784',
  'page.millisecondsFormat': 'मिलीसेकंड (13-अंक)',
  'page.millisecondsFormatDesc': 'मिलीसेकंड सटीकता के साथ विस्तारित टाइमस्टैम्प। उदाहरण: 1734598784000',

  'page.whyUseTimestampTitle': 'हम Unix समय का उपयोग क्यों करते हैं?',
  'page.reason1Title': 'समय क्षेत्र स्वतंत्र',
  'page.reason1Desc': 'टाइमस्टैम्प UTC समय का प्रतिनिधित्व करते हैं, वैश्विक अनुप्रयोगों में समय क्षेत्र भ्रम को समाप्त करते हैं।',
  'page.reason2Title': 'आसान गणना',
  'page.reason2Desc': 'समय के अंतर और अवधि की गणना के लिए सरल अंकगणितीय संचालन।',
  'page.reason3Title': 'डेटाबेस के अनुकूल',
  'page.reason3Desc': 'डेटाबेस इंडेक्सिंग और सॉर्टिंग के लिए सही कॉम्पैक्ट पूर्णांक संग्रहण प्रारूप।',
  'page.reason4Title': 'सार्वभौमिक मानक',
  'page.reason4Desc': 'वस्तुतः सभी प्रोग्रामिंग भाषाओं और प्लेटफार्मों द्वारा समर्थित।',
  'page.year2038Problem': '2038 में क्या होता है? (वर्ष 2038 समस्या)',
  'page.year2038Content': 'वर्ष 2038 समस्या (जिसे Y2038 या Unix मिलेनियम बग के रूप में भी जाना जाता है) उस समय को संदर्भित करती है जब 32-बिट Unix टाइमस्टैम्प ओवरफ्लो हो जाएंगे। 19 जनवरी 2038 को, 03:14:07 UTC पर, हस्ताक्षरित 32-बिट पूर्णांक अपने अधिकतम मान (2,147,483,647) तक पहुंच जाएंगे और नकारात्मक संख्याओं में लपेट जाएंगे। 64-बिट टाइमस्टैम्प का उपयोग करने वाली आधुनिक प्रणालियां प्रभावित नहीं होती हैं और भविष्य में अरबों वर्षों तक तारीखों का प्रतिनिधित्व कर सकती हैं।',

  // Coding examples section
  'page.codingExamples': 'विभिन्न प्रोग्रामिंग भाषाओं में वर्तमान टाइमस्टैम्प कैसे प्राप्त करें',
  'page.codeCheatSheet': 'Unix टाइमस्टैम्प कोड चीट शीट (भाषा के अनुसार)',
  'page.howToGetTimestamp': 'वर्तमान टाइमस्टैम्प कैसे प्राप्त करें',
  'page.convertToDate': 'टाइमस्टैम्प को तारीख ऑब्जेक्ट में कन्वर्ट करें',
  'page.convertToTimestamp': 'तारीख को टाइमस्टैम्प में कन्वर्ट करें',
  'page.getCurrentTimestamp': 'वर्तमान टाइमस्टैम्प प्राप्त करें',
  'page.getMilliseconds': 'मिलीसेकंड टाइमस्टैम्प प्राप्त करें',
  'page.getSeconds': 'सेकंड टाइमस्टैम्प प्राप्त करें',

  // Timestamp to Date conversion examples
  'page.timestampToDateExamples': 'Unix टाइमस्टैम्प को तारीख/समय में कैसे कन्वर्ट करें',
  'page.timestampToDateDesc': 'विभिन्न प्रोग्रामिंग भाषाओं में Unix टाइमस्टैम्प को मानव-पठनीय तारीख और समय प्रारूपों में कैसे कन्वर्ट करें, सीखें। चाहे आपके पास सेकंड या मिलीसेकंड टाइमस्टैम्प हों, ये उदाहरण आपको उचित रूपांतरण विधियां दिखाते हैं।',
  'page.convertTimestampToDate': 'टाइमस्टैम्प को तारीख में कन्वर्ट करें',
  'page.fromMilliseconds': 'मिलीसेकंड टाइमस्टैम्प से',
  'page.fromSeconds': 'सेकंड टाइमस्टैम्प से',
  'page.formatOptions': 'कस्टम विकल्पों के साथ प्रारूप',
  'page.toUTC': 'UTC में कन्वर्ट करें',
  'page.formatDate': 'तारीख को प्रारूपित करें',

  // Date to Timestamp conversion examples
  'page.dateToTimestampExamples': 'तारीख/समय को Unix टाइमस्टैम्प में कैसे कन्वर्ट करें',
  'page.dateToTimestampDesc': 'विभिन्न प्रोग्रामिंग भाषाओं में तारीखों और समय को Unix टाइमस्टैम्प में कैसे कन्वर्ट करें, सीखें। ये उदाहरण तारीख स्ट्रिंग पार्स करने, तारीख घटकों से टाइमस्टैम्प बनाने और सेकंड और मिलीसेकंड दोनों प्रारूपों को संभालने का प्रदर्शन करते हैं।',
  'page.convertDateToTimestamp': 'तारीख को टाइमस्टैम्प में कन्वर्ट करें',
  'page.fromDateString': 'तारीख स्ट्रिंग से',
  'page.fromDateComponents': 'तारीख घटकों से',
  'page.parseString': 'तारीख स्ट्रिंग पार्स करें',
  'page.monthNote': 'नोट: महीना 0-अनुक्रमित है',
  'page.useCalendar': 'Calendar का उपयोग करना',
  'page.parseFormat': 'प्रारूप के साथ पार्स करें',
  'page.fromComponents': 'समय घटकों से',
  'page.currentTime': 'वर्तमान टाइमस्टैम्प प्राप्त करें',
  'page.fromDatetime': 'datetime कॉलम से',

  // How to use
  'page.howToUse': 'इस टाइमस्टैम्प कनवर्टर का उपयोग कैसे करें',
  'page.step1': '📊 वर्तमान टाइमस्टैम्प: सेकंड (10 अंक) और मिलीसेकंड (13 अंक) दोनों प्रारूपों में वास्तविक समय Unix टाइमस्टैम्प देखें। टाइमस्टैम्प को अपने क्लिपबोर्ड पर तुरंत कॉपी करने के लिए कॉपी बटन पर क्लिक करें।',
  'page.step2': '🔄 टाइमस्टैम्प से डेटाटाइम: Unix टाइमस्टैम्प दर्ज करें और चुनें कि यह सेकंड या मिलीसेकंड प्रारूप में है या नहीं। GMT, आपके स्थानीय समय क्षेत्र, ISO 8601 और सापेक्ष समय सहित कई प्रारूपों में संबंधित तारीख और समय देखने के लिए कन्वर्ट करें।',
  'page.step3': '📅 डेटाटाइम से टाइमस्टैम्प: तारीख पिकर का उपयोग करके कोई भी तारीख और समय चुनें, या वर्तमान समय का उपयोग करने के लिए "अभी" पर क्लिक करें। तुरंत सेकंड और मिलीसेकंड दोनों टाइमस्टैम्प प्रारूप प्राप्त करने के लिए कन्वर्ट करें।',
  'page.step4': '💡 त्वरित सुझाव: Unix टाइमस्टैम्प 1 जनवरी 1970 00:00:00 UTC के बाद से सेकंड/मिलीसेकंड की संख्या है। सेकंड के लिए 10-अंक प्रारूप, मिलीसेकंड के लिए 13-अंक का उपयोग करें। सभी रूपांतरण तात्कालिक हैं और ऑफ़लाइन काम करते हैं।',

  // Related Tools
  'page.relatedTools': 'संबंधित समय टूल',
  'page.relatedToolsDesc': 'हमारे अन्य पेशेवर समय प्रबंधन टूल का अन्वेषण करें',
  'page.timerTool': 'ऑनलाइन टाइमर',
  'page.timerToolDesc': 'पोमोडोरो तकनीक, खाना पकाने, अध्ययन और काम के ब्रेक के लिए बिल्कुल सही काउंटडाउन टाइमर',
  'page.stopwatchTool': 'स्टॉपवॉच',
  'page.stopwatchToolDesc': 'खेल प्रशिक्षण और समय के लिए मिलीसेकंड सटीकता के साथ उच्च-सटीक स्टॉपवॉच',
  'page.worldClockTool': 'विश्व घड़ी',
  'page.worldClockToolDesc': 'दुनिया भर के प्रमुख शहरों में वर्तमान समय दिखाने वाली वास्तविक समय विश्व घड़ी',

  // Specialized Tools
  'page.specializedTools': 'विशेष टाइमस्टैम्प टूल',
  'page.specializedToolsDesc': 'विभिन्न प्लेटफार्मों और उपयोग के मामलों के लिए विशेष टाइमस्टैम्प टूल का अन्वेषण करें',
  'page.discord.desc': 'Discord इवेंट के लिए स्वचालित टाइमज़ोन रूपांतरण के साथ <t:format> कोड जेनरेट करें',
  'page.discord.topSearch': 'शीर्ष खोज',
  'page.discord.searchesPerMonth': 'मासिक खोज',
  'page.youtube.desc': 'विशिष्ट समय पर शुरू होने वाले साझा करने योग्य YouTube लिंक बनाएं',
  'page.youtube.popular': 'लोकप्रिय',

  // Programming Guides
  'page.programmingGuides': 'प्रोग्रामिंग भाषा टाइमस्टैम्प गाइड',
  'page.programmingGuidesDesc': 'प्रत्येक प्रोग्रामिंग भाषा के लिए टाइमस्टैम्प हैंडलिंग विधियां, फ़ंक्शन और सर्वोत्तम प्रथाओं को सीखें',
  'page.sql.desc': 'MySQL, PostgreSQL, Oracle, SQL Server टाइमस्टैम्प हैंडलिंग',
  'page.sql.highPriority': 'उच्च प्राथमिकता',
  'page.sql.searches': 'खोज',
  'page.python.desc': 'datetime, time, calendar मॉड्यूल गाइड',
  'page.python.popular': 'लोकप्रिय',
  'page.javascript.desc': 'Date ऑब्जेक्ट, Day.js, date-fns लाइब्रेरी गाइड',
  'page.javascript.common': 'सामान्य',
  'page.codeExamplesNote': 'पूर्ण कोड उदाहरण, सर्वोत्तम प्रथाएं और FAQs शामिल हैं',
};
